export default __webpack_public_path__ + "static/media/webtrader-error-message-background.36cf9012.svg";